import * as React from 'react';

import { formatPostCode, validatePostCode } from '@funnels/utils';

import TextInputField, { TextInputFieldProps } from '.';

export const PostCodeInputFieldLabel = 'Postcode';
export const PostCodeInputFieldValidationFailMessage = 'Please enter a valid postcode.';

const PostCodeInputField = (props: TextInputFieldProps) => {
  const { label = PostCodeInputFieldLabel, ...rest } = props;
  return (
    <TextInputField
      {...rest}
      format={formatPostCode}
      label={label}
      parse={formatPostCode}
      validate={validatePostCode(PostCodeInputFieldValidationFailMessage)}
    />
  );
};

export default PostCodeInputField;
